<template>
    <div id="login">
        <ValidationObserver ref="observer">
            <v-form novalidate ref="login-form" method="post" action="/login" style="margin-top: -20%">
                <v-img
                    src="/images/eTRAINING-S.svg"
                    class="img-responsive"
                    style="width: 45%; height: auto; margin: auto"
                    :alt="translations.app_name"
                />
                <v-card tile>

                    <v-card-text>
                        <v-toolbar-title>
                            <p>{{ translations.auth.login }}</p>
                        </v-toolbar-title>

                        <v-alert type="error" dismissible v-model="hasError">
                            {{ n_errors[0] }}
                        </v-alert>

                        <ValidationProvider rules="required" v-slot="{ errors }" :name="translations.auth.username">
                            <v-text-field
                                :label="translations.auth.username"
                                prepend-inner-icon="fas fa-user"
                                type="text"
                                v-model="input.username"
                                :error-messages="errors[0]"
                                name="username"
                            />
                        </ValidationProvider>

                        <ValidationProvider rules="required" v-slot="{ errors }" :name="translations.auth.password">
                            <v-text-field
                                id="password"
                                :label="translations.auth.password"
                                prepend-inner-icon="fas fa-lock"
                                type="password"
                                v-model="input.password"
                                :error-messages="errors[0]"
                                name="password"
                            />
                        </ValidationProvider>

                        <v-checkbox
                            :label="translations.auth.remember"
                            color="primary"
                            v-model="input.remember"
                            name="remember"
                            value="true"
                            true-value="true"
                            false-value=""
                        />

                        <input type="hidden" name="_token" :value="csrf">

                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="primary" text href="/password/reset">{{ translations.auth.forgot_password }}</v-btn>
                        <div class="flex-grow-1"></div>
                        <v-btn color="primary" type="submit" @click.native="submit">{{ translations.auth.login }}</v-btn>
                    </v-card-actions>

                </v-card>

                <a
                    href="https://support.etools-s.com/scp/login.php"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="support-banner d-block text-center white--text pa-4 mb-4"
                    style="text-decoration: none;"
                >
                    Need help? Click here for support.
                </a>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
    export default {
        name: "Login",
        props: {
            username: String,
            trans: String | Object,
            errors: String | Array,
            csrf: String,
        },
        data() {
            return {
                input: {
                    username: '',
                    password: '',
                    remember: 'true',
                },
                translations: {
                    app_name: '',
                    auth: {
                        login: 'Login',
                        username: 'Username',
                        password: 'Password',
                        remember: 'Remember me',
                        failed: 'These credentials do not match our records',
                        forgot_password: 'Forgot Password?',
                    },
                },
                n_errors: [],
            };
        },
        computed: {
            hasError() {
                return this.n_errors.length > 0;
            }
        },
        methods: {
            async submit(event) {
                let valid = await this.$refs.observer.validate();

                if (!valid) {
                    event.preventDefault();
                }
            },
            getTranslations(translations) {
                let key,
                    translated = {};

                if (typeof translations === 'string') {
                    translations = JSON.parse(translations);
                }

                for (key in translations) {
                    if (!translations.hasOwnProperty(key)) {
                        continue;
                    }

                    if (typeof translations[key] !== 'string') {
                        translations[key] = this.getTranslations(translations[key]);
                    }

                    translated[key] = translations[key];
                }

                return translated;
            },
        },
        created() {
            this.input.username = this.username;

            if (typeof this.errors == 'string') {
                this.n_errors = JSON.parse(this.errors);
            } else {
                this.n_errors = this.errors;
            }

            this.translations = this.getTranslations(this.trans);
        }
    };
</script>
